define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PastureUnitDomain = void 0;
    class PastureUnitDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: PastureUnitDomain.KgHa, value: "kg/ha" },
                    { key: PastureUnitDomain.Cm, value: "cm" },
                    { key: PastureUnitDomain.Pc, value: "%" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[PastureUnitDomain.KgHa] = 0;
                this.KeyIndex[PastureUnitDomain.Cm] = 1;
                this.KeyIndex[PastureUnitDomain.Pc] = 2;
                this.ValueIndex = {};
                this.ValueIndex["kg/ha"] = 0;
                this.ValueIndex["cm"] = 1;
                this.ValueIndex["%"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.PastureUnitDomain = PastureUnitDomain;
    Object.defineProperty(PastureUnitDomain, "KgHa", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "D"
    });
    Object.defineProperty(PastureUnitDomain, "Cm", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "H"
    });
    Object.defineProperty(PastureUnitDomain, "Pc", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "P"
    });
    Object.defineProperty(PastureUnitDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
